const loadTabs = () => {
    const tabs = document.getElementById('tabs')

    if (tabs) {
        tabs.addEventListener('click', event => {
            event.preventDefault()

            const actives = document.querySelectorAll('.active')
            for (let active of actives) {
                active.className = active.className.replace('active', '')
            }

            event.target.className += ' active'
            document.getElementById(event.target.href.split('#')[1]).className += ' active'
        })
    }
}

export default loadTabs



// WEBPACK FOOTER //
// ./js/tabs.js